
export function sortEntries(entries) {
    return entries.sort((a, b) => 
        a.sortOrder - b.sortOrder
    );
}
